import * as types from "../actions/ActionTypes";
import { DogPlanDetails } from "../store/InitialStore";
export default function DogPlanDetailsReducer(state = DogPlanDetails, action) {
  const { type, payload } = action;
  switch (type) {
    case types.DOG_PLAN_DETAILS_SUCCESS:
      return {
        categoryDetails: payload,
      };
    case types.DOG_PLAN_DETAILS_RESET:
      return {
        categoryDetails: payload,
      };

    default:
      return state;
  }
}
